import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { NewsEventTermsQuery } from '@custom/schema';

export const useNewsEventsTermsQuery = () =>
  useStaticQuery(graphql(NewsEventTermsQuery));
